import { api } from '../configs/axiosConfigs';
import { WholesalerProfile } from '../../utility/wholesale';

export const getWholesalerProfile = async () => api.get('/wholesaler_profile');
export const saveWholesalerProfile = async (values: Partial<WholesalerProfile>) =>
  api.put('/wholesaler_profile', { wholesaler_profile: values });

export const getMyWholesaleDeals = async () => api.get('/wholesale_deals');
export const createWholesaleDeal = async (body: FormData) =>
  api.post('/wholesale_deals', body, { headers: { 'Content-Type': 'multipart/form-data' } });
export const updateWholesaleDeal = async (id: string, body: FormData) =>
  api.put(`/wholesale_deals/${id}`, body, { headers: { 'Content-Type': 'multipart/form-data' } });
export const deleteWholesaleDeal = async (id: string) => api.delete(`/wholesale_deals/${id}`);
export const getDealForProperty = async (propertyId: string) => api.get(`/wholesale_deals/for_property/${propertyId}`);
